/**
 * Angular imports.
 */
import { Component, OnInit, Output, EventEmitter, Input, OnDestroy, OnChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

/**
 * Rxjs imports.
 */
import { Subscription, timer as observableTimer } from 'rxjs';

/**
 * Service imports.
 */
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { MultiLangService } from '../../dataservices/master-service/multi-lang.service';
import { GetService } from '../../dataservices/get.service';
import { PostApiService } from '../../dataservices/post-api.service';
import { Location, LocationStrategy } from '@angular/common';
import { DataStorageService } from '../../dataservices/data-storage.service';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';
import { NewLanguageService } from '../../dataservices/new-language/new-language.service';
import { ButtonDirective } from '../../directives/ga.directive';

/**
 * Environment imports.
 */
import { environment } from '../../../environments/environment';

/**
 * Import Interface or modal.
 */
import { MediaItem } from './../web-cme-modal';
/**
 * Constant file import.
 */
import { MEDIA_TYPE, PRODUCT_TYPE_CONSTANT, CME_TYPE } from './../../constants/app.constants';
import { CME_DETAIL_DESCRIPTION, LockedContentCMEModule } from 'src/app/interface/cme/details';
import { CME_LOCAL_STORAGE } from 'src/app/constants/featureConstants/cme.constants';
import { Course } from 'src/app/onboarding/interface/global.model';

let id = 0;

/**
 * Web Cme Detail Modal Component
 */
@Component({
  selector: 'app-web-cme-detail-modal',
  templateUrl: './web-cme-detail-modal.component.html',
  styleUrls: ['./web-cme-detail-modal.component.scss']
})
export class WebCmeDetailModalComponent implements OnInit, OnChanges, OnDestroy {
  @Output() cmeDetail = new EventEmitter();
  @Input() courseId;
  @Input() callon;
  @Input() update_certificate;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public ngbDDL: any;

  /**
   * variable for product type
   */
  public pType = PRODUCT_TYPE_CONSTANT;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  /**
   * complete detail of cme data 
   */
  public cmeDetailData!: Course;
  public finished = false;
  public finishedDesc = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  /**
   * cme detail description
   */
  public cmeDetailDesc: CME_DETAIL_DESCRIPTION;
  public cme_bookmark_loader = false;
  public descDontshow = false;
  public type = 'preview';
  public openMediaIndex = 0;
  public mediaModal = false;
  public certificateMediaModal = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public mediaObj: any = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public channel: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public certificateMediaObj: any = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public subscribe_obj: any;
  public screen_name = 'generate_certificate';
  public hasChanged = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public certificateType: any;
  public showSubscribeModal = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public restrictError: any;
  public showrestrict = false;
  public page_from = this.mls.googleEventText.cme_details.category;
  public course_id = 0;
  public isActionModalShown = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public actionData: any;
  /**
   * Release version 12 for quiz card
   */
  public releaseVersion = '12';

  /**
   * Key used to store the previous route.
   */
  public previousRoute: string;

  /**
   * Key used to store the array of objects of media.
   */
  public bannerMedia: MediaItem;

  /**
   * Key used to access the constants value.
   */
  public mediaType = MEDIA_TYPE;
  /**
   * Cme Types constant.
   */
  public Cme_Type = CME_TYPE;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();
  /**
   * in case of locked content 
   * part of module cme
   * show popup
   */
  public lockedContentPopup : LockedContentCMEModule= {
    togglePopup : false,
    popupDetails : null
  }; 
  /**
   * Cme API status.
   */
  public cmeStatus: number;

  /**
   * Necessary instances
   */
  constructor(
    private _location: Location,
    public getService: GetService,
    public fcs: FunCollectionService,
    public multiLangService: MultiLangService,
    private route: ActivatedRoute,
    private postSer: PostApiService,
    public masterService: MasterserviceService,
    private router: Router,
    public Dss: DataStorageService,
    private jwtSer: JwtDecodeService,
    public mls: NewLanguageService,
    private directive_ser: ButtonDirective,
    private locationStrategy: LocationStrategy
  ) {
    const d = new Date();
    this.fcs.sessiontime.start_time = d.getTime().toString();
    sessionStorage.setItem('sessionstarttime', d.getTime().toString());
    environment.ideal_state.current_page = this.page_from;

    this.subscriptions.add(this.route.params.subscribe(params => {
      id = (params['id']);
    }));
  }

  /**
   * initialize NgbDdl
   */
  initializeNgbDdl(): void {
    this.ngbDDL = {
      class: 'l', calling_from: 'cmedetail',
      data: [
        { index: 0, action: 'report', text: this.mls.languageText.cme_details.key14, product_type: 8, product_type_id: this.cmeDetailData.course_id },
      ]
    };
  }

  /**
   * check User Ideal State
   */
  checkUserIdealState(): void {

    this.subscriptions.add(observableTimer(0, 5000)
      .subscribe(() => {
        environment.ideal_state.ideal_state_timer = environment.ideal_state.ideal_state_timer + 5000;
        if (environment.ideal_state.ideal_state_timer >= environment.ideal_state.ideal_state_time) {
          if (environment.ideal_state.is_ideal_state == false && environment.ideal_state.current_page == this.page_from) {
            setTimeout(() => {
              const d = new Date();
              if (sessionStorage.getItem('sessionstarttime') != null) {
                this.fcs.sessiontime.start_time = sessionStorage.getItem('sessionstarttime');
              }
              this.fcs.sessiontime.end_time = d.getTime().toString();
              this.directive_ser.productDetailEvent(Object.assign({}, this.fcs.sessiontime), this.mls.googleEventText.cme_details.key10, 8, id, this.page_from, this.Dss.user_profile_data.profile.track_id);
              environment.ideal_state.ideal_state_timer = 0;
              environment.ideal_state.is_ideal_state = true;
            }, 500);
          }
        }
      }));
  }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.checkUserIdealState();
    this.getCmeDetail();
    this.getCmeDesc();
    sessionStorage.removeItem('queArr');
    this.fcs.IsUserActiveOnApp(this.page_from);
    this.subscriptions.add(this.Dss.is_browser_tab_active_action.subscribe(data => {
      if (data.page_from == this.page_from && data.is_visible == 0) {
        if (sessionStorage.getItem('sessionstarttime') != null) {
          this.fcs.sessiontime.start_time = sessionStorage.getItem('sessionstarttime');
        }
        const d = new Date();
        this.fcs.sessiontime.end_time = d.getTime().toString();

        this.directive_ser.productDetailEvent(Object.assign({}, this.fcs.sessiontime), this.mls.googleEventText.cme_details.key10, 8, this.cmeDetailData.course_id, this.page_from, this.Dss.user_profile_data.profile.track_id);
        environment.ideal_state.is_ideal_state = true;
      } else if (data.page_from == this.page_from && data.is_visible == 1) {
        setTimeout(() => {
          const dd = new Date();
          this.fcs.sessiontime.start_time = dd.getTime().toString();
          sessionStorage.setItem('sessionstarttime', dd.getTime().toString());
        }, 1000);
      }
    }));

    /**
     * Get previous route.
     */
    this.previousRoute = this.fcs.previousRoute;
    if (this.previousRoute === '/cme/questions') {
      history.pushState(null, null, location.href);
      this.locationStrategy.onPopState(() => {
        history.pushState(null, null, location.href);
      });
    }
  }

  /**
   * OnChanges
   */
  ngOnChanges(): void {
    if (this.cmeDetailData?.certificate_url == '' || this.cmeDetailData?.certificate_url == undefined && this.cmeDetailData) {
      this.cmeDetailData.certificate_url = this.update_certificate;
    }
  }

  /**
   * view Certificate
   */
  viewCertificate(): void {
    this.certificateMediaModal = false;
    if (this.cmeDetailData.certificate_url != '' && this.cmeDetailData.certificate_url != undefined) {
      this.certificateMediaModal = true;
    } else {
      this.subscriptions.add(this.postSer.generateCmeCertificate(this.cmeDetailData.course_id).subscribe(resData => {
        this.jwtSer.decodeData(resData).then(data => {
          if (data['status'] == 1) {
            this.cmeDetailData.certificate_url = data['data'].pdf_url;
            this.cmeDetail.emit(this.cmeDetailData);
            localStorage.setItem('cmeDetail', JSON.stringify(this.cmeDetailData));
            const stringToSplit = this.cmeDetailData.certificate_url;
            if (stringToSplit != null && stringToSplit != '') {
              const x = stringToSplit.split('.');
              this.certificateType = x[x.length - 1];
            }
            this.certificateMediaObj = [];
            const t = {
              media_id: 1,
              media_name: 'certificate',
              media_thumbnail: '',
              media_type: 'document',
              media_url: this.cmeDetailData.certificate_url
            };
            this.certificateMediaObj.push(t);
            this.certificateMediaModal = true;
            this.hasChanged = !this.hasChanged;
          } else {
            this.fcs.errorHandeler(data, this.screen_name);
            return;
          }
        });
      }));
    }
  }

  /**
   * Used to redirect to leader board page
   */
  navigateToLeaderBoard(): void {
    window.open(this.cmeDetailData.quiz_leaderboard_url, '_blank');
  }

  /**
   * get Cme Detail
   */
  getCmeDetail(): void {
    this.showrestrict = false;

    this.finished = false;
    this.subscriptions.add(this.getService.getCmeDetail(this.courseId, this.type).subscribe(resData => {
      this.finished = true;      
      this.jwtSer.decodeData(resData).then(data => {
        this.cmeStatus = data.status;
        if (data.status == 1) {
          this.cmeDetailData = data.data.course;
          this.channel = data.data.course.channel;
          this.bannerMedia = data.data.course.media.find((item: MediaItem) => item.is_default === 1);

          if (this.channel != null) {
            this.subscribe_obj = {
              'target_id': this.channel.channel_id,
              'channel_name': this.channel.title,
              'tnc_url': this.channel.tnc_url,
              'target_name': this.channel.powered_name,
              'target_label': this.channel.powered_by_label,
              'publication_logo': this.channel.channel_logo,
              'sponsor_footer_text': this.channel.sponsor_footer_text,
              'no_of_members': this.channel.no_of_members,
              'safe_url': this.channel.safe_url,
              'product_view': this.channel.is_product_view,
              'calling_from': 'cme_list_deatil',

            };
          }

          this.initializeNgbDdl();
          const stringToSplit = this.cmeDetailData.certificate_url;
          if (stringToSplit != null && stringToSplit != '') {
            const x = stringToSplit.split('.');
            this.certificateType = x[x.length - 1];
          }

          if (this.channel != null) {
            if (this.channel.is_subscribed == 0) {
              this.showSubscribeModal = true;
            }
          }

          if (this.cmeDetailData.certificate_url != '' && this.cmeDetailData.certificate_url != undefined) {
            const type = (this.certificateType == 'pdf') ? 'document' : 'image';
            const t = {
              media_id: 1,
              media_name: 'certificate',
              media_thumbnail: '',
              media_type: type,
              media_url: this.cmeDetailData.certificate_url
            };
            this.certificateMediaObj.push(t);
          }

          localStorage.setItem('cmeDetail', JSON.stringify(this.cmeDetailData));
          if(this.cmeDetailData.cme_type == CME_TYPE.MODULE)
            localStorage.setItem(CME_LOCAL_STORAGE.CME_PARENT_DATA,JSON.stringify(this.cmeDetailData.course_id));
          else if(this.cmeDetailData?.has_parent == 1 && !localStorage.getItem(CME_LOCAL_STORAGE.CME_PARENT_DATA))
            localStorage.setItem(CME_LOCAL_STORAGE.CME_PARENT_DATA,JSON.stringify(this.cmeDetailData.has_parent));
          else if(this.cmeDetailData?.has_parent == 0 || !this.cmeDetailData?.has_parent){
            localStorage.removeItem(CME_LOCAL_STORAGE.CME_PARENT_DATA);
          }
          // open media

          let t;
          for (let i = 0; i < this.cmeDetailData.media.length; i++) {
            t = {
              media_id: this.cmeDetailData.media[i].id,
              media_name: '',
              media_thumbnail: this.cmeDetailData.media[i].preview_url,
              media_type: this.cmeDetailData.media[i].file_type,
              media_url: this.cmeDetailData.media[i].file_url
            };
            this.mediaObj.push(t);
          }

          // close media


          if (this.type == 'download') {
            localStorage.setItem('cmeDetail', JSON.stringify(this.cmeDetailData));
            this.router.navigateByUrl('cme/questions');
          }
          this.cmeDetail.emit(this.cmeDetailData);

          if(this.cmeDetailData.module_validation != null){     
              this.lockedContentPopup.togglePopup = true;
              this.lockedContentPopup.popupDetails = this.cmeDetailData.module_validation;
          }else{
            this.lockedContentPopup.togglePopup = false;
          }

        } else if (data.status === 0) {
          if (data.data === null) { 
           this.showrestrict = true;
           this.restrictError = data.error.msg;
         }
         else if (data['action'].type === 'alert') {
           this.isActionModalShown = true;
           this.actionData = data['action'];
           return;
         } else {
           this.restrictError = data.error.msg;
           this.showrestrict = true;
         }
       }

      });
    }));
  }

  /**
   * back clicked
   */
  backclicked(): void {
    const hasParentId = localStorage.getItem(CME_LOCAL_STORAGE.CME_PARENT_DATA) ;    
    if(hasParentId && hasParentId != null && hasParentId!= 'null' && this.cmeDetailData.has_parent == 1 && JSON.parse(hasParentId) > 1){
      this.fcs.navigateToCmeDetail(parseInt(hasParentId));
    }
    else{      
      this.fcs.navigateToCmeDetail();
    }
  }

  /**
   * get Cme Desc
   */
  getCmeDesc(): void {
    this.finishedDesc = false;
    this.subscriptions.add(this.getService.getCmeDesc(this.courseId).subscribe(resData => {
      this.finishedDesc = true;
      this.jwtSer.decodeData(resData).then(data => {
        if (data.status == 1) {
          this.cmeDetailDesc = data.data;
        } else if (data.status == 0) {
          this.descDontshow = true;
        }
      });
    }));
  }

  /**
   * product share
   */
  productShare(): void {
    const x = [{ share_url: '', share_contentt: this.cmeDetailData.share_content, product_type: 8, product_type_id: this.cmeDetailData.course_id }];
    this.fcs.productShare(x);
  }

  /**
   * product Bookmark
   */
  productBookmark(): void {
    this.cme_bookmark_loader = true;
    const action = (this.cmeDetailData.is_bookmarked == 0) ? 'add' : 'delete';
    this.subscriptions.add(this.postSer.productBookmark(8, this.cmeDetailData.course_id, action).subscribe(resData => {
      this.cme_bookmark_loader = false;
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] == 1) {
          this.fcs.showSuccess(data['msg'], 'Success');
          this.cmeDetailData.is_bookmarked = (action == 'add') ? 1 : 0;
        } else if (data['status'] == 0) {
          this.fcs.showError(data['msg'], 'Error');
          this.fcs.errorHandeler(data);
          return;
        }
      });
    }));
  }

  /**
   * attempt Cme
   */
  attemptCme(): void {
    this.type = 'download';
    this.getCmeDetail();
  }

  /**
   * set Reset Media Modal
   */
  setResetMediaModal(val, indx): void {
    if (indx == undefined) {
      this.openMediaIndex = 0;
    }
    this.mediaModal = val;
    if (indx != '' && indx != undefined) {
      this.openMediaIndex = indx;
    }
  }

  /**
   * set Reset Certificate Modal
   */
  setResetCertificateModal(val, indx): void {
    if (indx == undefined) {
      this.openMediaIndex = 0;
    }
    this.certificateMediaModal = val;
    if (indx != '' && indx != undefined) { this.openMediaIndex = indx; }
  }

  /**
   * reset NgbDD LRecord
   */
  resetNgbDDLRecord(): void {
    // No Code
  }

  /**
   * subscribe cancel
   */
  subbackClicked(): void {
    if (this.channel.is_product_view == 0) {
      this._location.back();
    } else if (this.channel.is_product_view == 1) {
      this.showSubscribeModal = false;
    }
  }

  /**
   * reset subscribe cancel
   */
  resetSubscribeModal(): void {
    this.showSubscribeModal = false;
  }

  /**
   * has Subscribed
   */
  hasSubscribed(): void {
    this.channel.is_subscribed = 1;
  }

  /**
   * redirect to parent module 
   *  if child module is locked/ restricted content-(1035 api code)
   */
  public redirectToParentModule(data : LockedContentCMEModule){
    this.fcs.navigateForCmeModule(data.popupDetails.target.type,data.popupDetails.target.id,true);
  }

  /**
   * ngOnDestroy
   */
  ngOnDestroy(): void {
    if (this.cmeDetailData != undefined) {
      const d = new Date();

      if (sessionStorage.getItem('sessionstarttime') != 'null') {
        this.fcs.sessiontime.start_time = sessionStorage.getItem('sessionstarttime');
      }
      this.fcs.sessiontime.end_time = d.getTime().toString();
      this.directive_ser.productDetailEvent(Object.assign({}, this.fcs.sessiontime), this.mls.googleEventText.cme_details.key10, 8, this.cmeDetailData.course_id, this.page_from, this.Dss.user_profile_data.profile.track_id);
    }
    environment.ideal_state.current_page = '';
    this.fcs.IsUserActiveOnApp('');
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  /**
   * reset Action Modal
   */
  resetActionModal(): void {
    this.isActionModalShown = false;
  }

  /**
   * Function is used to get specialty.
   */
  getSpecialty(speciality): void {
    this.Dss.specialty_filter = speciality;
    this.router.navigate(['/web/list']);
  }
}
